import * as React from 'react';
import Tag from '../tag';
import {TagProps} from "antd/lib/tag";

export default function PickerTag(props: TagProps) {
  return <Tag color="blue" {...props} />;
}



// WEBPACK FOOTER //
// ./src/components/date-picker/PickerTag.tsx